import type { ContentPaper } from '~/typesManual/content_api/paper'

interface TrialModalState {
  open: boolean
  papers?: ContentPaper[]
  skipStartTrial?: boolean
  returnUrl?: string
}

export const useTrialModalState = () => {
  return useState<TrialModalState>('trialModalState', () => ({
    open: false,
  }))
}
